import axios from "axios";

// const url = "http://192.168.29.242/projects/schoolErp/";
// const url = "https://api.sarvajna.co.in/erp/";

// const url = "https://sarvajna.onezo.in/api/";

// const url = "http://192.168.1.103/projects/erp.sarvanjya-api/";


const url = "https://edu.onezo.in/erp/";
// const url = "https://api.elitegroupofinsitutions.com/erp/";




export const axiosInstance = axios.create({
  baseURL: url,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
